export const enum ScreenTypes {
	INVOICES = 'INVOICES',
}
